// src/reducers/dailyReportReducer.js
import {
    FETCH_DAILY_REPORT_SUCCESS,
    UPDATE_DAILY_REPORT_SUCCESS,
  } from '../actions/dailyReportActions';
  
  const initialState = {
    date: null,
    photo_link: '',
    general_info: '',
    general_photo_link: '',
  };
  
  const dailyReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DAILY_REPORT_SUCCESS:
      case UPDATE_DAILY_REPORT_SUCCESS:
        return {
          ...state,
          ...action.payload,
        };
      default:
        return state;
    }
  };
  
  export default dailyReportReducer;
  
